import { render, staticRenderFns } from "./OPDSpaceForMobile.vue?vue&type=template&id=5a99323a&scoped=true"
import script from "./OPDSpaceForMobile.vue?vue&type=script&lang=js"
export * from "./OPDSpaceForMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a99323a",
  null
  
)

export default component.exports